@if (dashboard_status?.length && dashboard_status?.toLocaleLowerCase() == 'future' ) {
<div [ngClass]="{ customFont: customFont }" class="red-status-back-ground">Later</div>
} @if (dashboard_status?.length && dashboard_status?.toLocaleLowerCase() == 'now' ) {
<div [ngClass]="{ customFont: customFont }" class="status-back-ground">
  {{ dashboard_status == 'Update As Soon as Possible' ? 'Update ASAP' : dashboard_status }}
</div>
} @if (dashboard_status?.length && dashboard_status?.toLocaleLowerCase() == 'set up complete' ) {
<div [ngClass]="{ customFont: customFont }" class="status-back-ground">
  {{ dashboard_status == 'Update As Soon as Possible' ? 'Update ASAP' : dashboard_status }}
</div>
} @if (dashboard_status?.length && dashboard_status?.toLocaleLowerCase() == 'set up in progress') {
<div [ngClass]="{ customFont: customFont }" style="text-align: left; width: fit-content" class="blue-status-back-ground">
  {{ dashboard_status == 'Update As Soon as Possible' ? 'Update ASAP' : dashboard_status }}
</div>
} @if (dashboard_status?.length && dashboard_status?.toLocaleLowerCase() == 'set up not started') {
<div [ngClass]="{ customFont: customFont }" style="text-align: left; width: fit-content" class="yellow-status-back-ground">
  {{ dashboard_status == 'Update As Soon as Possible' ? 'Update ASAP' : dashboard_status }}
</div>
} @if (dashboard_status?.length && dashboard_status?.toLocaleLowerCase() == 'deactivated') {
<div [ngClass]="{ customFont: customFont }" style="text-align: center; width: 132px" class="gray-status-back-ground">
  {{ dashboard_status == 'Update As Soon as Possible' ? 'Update ASAP' : dashboard_status }}
</div>
}
